import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetMandatoryAttributeNamesQuery } from '../../api/createProjectApiSlice';
import { addConcept, AddedConcept, clearConceptInEditMode } from '../../state/createProjectSlice';
import { selectAddedConcepts } from '../../state/selector';

interface UseConceptGroupsAndAttributesResults {
  handleAddConcept: () => void;
  addedConceptCount: number;
  addedConcepts: AddedConcept[];
  mandatoryAttributeNames: string[];
  mandatoryAttributeNamesLoading: boolean;
}

interface ConceptGroupsAndAttributesStepProps {
  setRequiredFieldsFilled: (fieldsFilled: boolean) => void;
}
export const useConceptGroupsAndAttributes = ({
  setRequiredFieldsFilled,
}: ConceptGroupsAndAttributesStepProps): UseConceptGroupsAndAttributesResults => {
  const addedConcepts = useAppSelector(selectAddedConcepts);
  const dispatch = useAppDispatch();

  const handleAddConcept = () => {
    const conceptCardId = `frontend-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const concept = {
      conceptCardId: conceptCardId,
      conceptGroupName: '',
      requiredAttributes: [],
      inEditMode: true,
    };
    dispatch(clearConceptInEditMode());
    dispatch(addConcept(concept));
  };

  const addedConceptCount = addedConcepts.filter((concept) =>
    concept.conceptGroupName.trim()
  ).length;

  useEffect(() => {
    const hasDraft = addedConcepts.some((c) => c.inEditMode);

    const hasFinalConcept = addedConcepts.some((c) => c.conceptGroupName?.trim() && !c.inEditMode);

    const hasValidConcept = hasFinalConcept && !hasDraft;

    setRequiredFieldsFilled(hasValidConcept);
  }, [addedConcepts, setRequiredFieldsFilled]);

  const {
    data: mandatoryAttributeNames,
    isLoading: mandatoryAttributeNamesLoading,
    isFetching: isMandatoryAttributeNamesFetching,
  } = useGetMandatoryAttributeNamesQuery();

  return {
    handleAddConcept,
    addedConceptCount,
    addedConcepts,
    mandatoryAttributeNames: mandatoryAttributeNames?.data ?? [],
    mandatoryAttributeNamesLoading:
      mandatoryAttributeNamesLoading || isMandatoryAttributeNamesFetching,
  };
};
